export const ApiAccessTokenDemoData = [
    {
        id: 11112,
        user: {
            id: 2,
            firstName: 'Kumar Bishojit',
            lastName: 'Paul',
            fullName: 'Kumar Bishojit Paul',
            organization: 'BIKIRAN',
            primaryEmail: 'bishojit@gmail.com',
            primaryPhone: '01717416667'
        },
        tokenName: '------------',
        description: 'Hello',
        status: 'active',
        timeExpire: 1727632800,
        timeCreated: 1725631376,
        demo: true
    },
    {
        id: 11113,
        user: {
            id: 3,
            firstName: 'Noman',
            lastName: 'Gazi',
            fullName: 'Noman Gazi',
            organization: 'Noman Gazi',
            primaryEmail: 'numan.islam61@gmail.com',
            primaryPhone: '01726387662'
        },
        tokenName: '------------',
        description: 'For testing purpose',
        status: 'active',
        timeExpire: 1727632800,
        timeCreated: 1725631377,
        demo: true
    }
];
export default null;
